import { useRef } from 'react';
import { useSelector } from 'react-redux'
import { useParams, Link } from 'react-router-dom'

import StatusOptionsMulti from '../components/psc/lib/StatusOptionsMulti'
import SearchBox from '../components/psc/lib/SearchBox'
import GncDataTable from '../components/psc/lib/GncDataTable'
import Loading from '../components/psc/lib/Loading'

import useAuthentication from '../hooks/useAuthentication';
import useUserManagement from '../hooks/useUserManagement';
import useTableSlots from '../hooks/useTableSlots'
import useProjectContents from '../hooks/useProjectContents'
import useBrowserTabTitle from '../hooks/useBrowserTabTitle'

const Reports = () => {
    const { projectID } = useParams()
    
    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project
    const isLoading = pscState.isLoading

    useBrowserTabTitle(`${project.project_code} Reports`)

    const table = useRef(null)
    const localStorageOrderKey = 'tblReportsOrder'
    const defaultOrder = [[ 1, 'asc' ]]

    const { currentUser } = useAuthentication();

    const {
        userHasProjectAccessLevel
    } = useUserManagement()

    const {
        isReportsLoaded,
        reports,
    } = useProjectContents()
    
    const {
        dateSlot,
        filePathSlot,
        linkSlot,
        ownerSlot
    } = useTableSlots()

    const columns = [
        { data: 'create_date' },
        { data: 'title' },
        { data: 'report_scheme.name' },
        { data: 'report_scheme.has_stages' },
        { data: 'report_status.name' }
    ]

    const tableSlots = {
        0: dateSlot,
        1: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/reports/${row.id}`),
        3: (data, type, row) => {
            if( data ) {
                return 'Tracking Report'
            } else {
                return 'Status Report'
            }
        }
    }

    const tableHead = (
        <tr>
            <th>Date</th>
            <th>Title</th>
            <th>Report Scheme</th>
            <th>Output</th>
            <th>Status</th>
        </tr>
    )

    const newButtons = []
    if( project && userHasProjectAccessLevel(currentUser, project.id, 'CADM_CONTROLLER')) {
        newButtons.push(
            <div key="newButtons">
                <Link to={`/portfolio/${project.id}/reports/new?has_stages=0`} key="newStatusReport" type="button" className="btn btn-mr btn-primary">New Status Report</Link>
                &nbsp;
                <Link to={`/portfolio/${project.id}/reports/new?has_stages=1`} key="newTrackingReport" type="button" className="btn btn-mr btn-primary">New Tracking Report</Link>
            </div>
        )
    }

    const showLoading = isLoading || !isReportsLoaded
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">

                        <div className="ibox-title">
                            <h2>Reports</h2>
                            {newButtons}
                            <div style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                <b>Status</b> reports snapshot the current state of all configured documents and records.
                                <span className="stonly reports-intro-1"></span>
                            </div>
                            <div style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                <b>Tracking</b> reports show changes to the live configuration baseline between key milestones and reviews.
                                <span className="stonly reports-intro-2"></span>
                            </div>
                            <div style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                All reports are created and managed by the CADM Controller.
                                <span className="stonly reports-intro-3"></span>
                            </div>
                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="4"
                                    fetchUrl="/v0/report_statuses"
                                    localStorageKey="report-list-statuses"
                                />
                            </div>

                            { showLoading ? <Loading /> : (
                                <GncDataTable
                                    tableRef={table}
                                    data={reports}
                                    defaultOrder={defaultOrder}
                                    localStorageOrderKey={localStorageOrderKey}
                                    columns={columns}
                                    tableSlots={tableSlots}
                                    tableHead={tableHead}
                                    tableFoot={tableHead}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Reports
